import alt from 'framework/alt';

class AuthorStore {
  constructor() {
    this.state = {
      authors: undefined,
    };

    this.on('bootstrap', () => {
      const { author } = this.state;
      const newAuthors = {};

      if (!Array.isArray(author)) {
        newAuthors[author.amazonAuthorId] = author;
      } else {
        author.forEach((currentAuthor) => {
          const aaid = currentAuthor.amazonAuthorId;
          if (!newAuthors[aaid]) {
            newAuthors[aaid] = currentAuthor;
          }
        });
      }

      this.setState({
        authors: newAuthors,
      });

      delete this.state.author;
    });
  }
}

export default alt.createStore(AuthorStore, 'AuthorStore');
